<template>
  <div class="public-content view-sku">
    <div class="breadcrumb"> 查看SKU组 <el-button round style="float:right;margin-top: 13px;" @click="undercarriageAll">批量下架</el-button>
    </div>
    <div class="right-main">
      <div class="data-list">
        <el-table :row-class-name="rowClassName" :data="tableData" border style="width: 100%" @selection-change="handleSelectionChange">
          <el-table-column type="selection" width="55">
          </el-table-column>
          <el-table-column label="SKU组id" prop="id" min-width="10px"></el-table-column>
          <el-table-column prop="skuGroupName" label="SKU组名称" min-width="10px"></el-table-column>
          <el-table-column label="SKU组图片" min-width="10">
            <template v-slot="scope">
              <img :src="scope.row.skuGroupImage" alt="">
            </template>
          </el-table-column>
          <el-table-column prop="dictSet" label="属性组合" min-width="10"></el-table-column>
          <el-table-column label="上架状态" min-width="10">
            <template slot-scope="scope">
              <div v-if="$hasPermission('pms:admin:sku:group:sale')">
                <span v-show="scope.row.onSale" @click="downDialog = true, downFrameId = scope.row.id" class="color-blue">已上架</span>
                <span v-show="!scope.row.onSale && scope.row.auditStatus !== 'WAIT_AUDIT'" class="color-blue" @click="skuId = scope.row.id, upDialog = true, upFrameId = scope.row.id">已下架</span>
              </div>
              <div v-else>
                <span v-show="scope.row.onSale">已上架</span>
                <span v-show="!scope.row.onSale && scope.row.auditStatus === 'WAIT_AUDIT'">已下架</span>
              </div>
            </template>
          </el-table-column>
          <el-table-column label="审核状态" min-width="10">
            <template slot-scope="scope">
              <span class="color-blue" v-permission="'pms:admin:sku:group:audit'" v-if="scope.row.auditStatus === 'WAIT_AUDIT'" @click="to(scope.row, '审核')">待审核</span>
              <span v-if="!$hasPermission('pms:admin:sku:group:audit') && scope.row.auditStatus === 'WAIT_AUDIT'">待审核</span>
              <span v-if="scope.row.auditStatus === 'AUDIT_FAIL'">审核拒绝</span>
              <span v-if="scope.row.auditStatus === 'AUDIT_SUCCESS'">已审核</span>
            </template>
          </el-table-column>
          <el-table-column prop="createdTime" label="创建日期" min-width="10"></el-table-column>
          <el-table-column label="操作" min-width="10px">
            <template v-slot="scope">
              <span class="color-blue" @click="to(scope.row, '查看')">查看<br></span>
              <span class="color-blue" @click="to(scope.row, '编辑')" v-permission="'pms:admin:sku:group:update'">编辑<br></span>
              <span class="color-blue" v-show="scope.row.auditStatus === 'WAIT_AUDIT'" @click="to(scope.row, '审核')" v-permission="'pms:admin:sku:group:audit'">审核<br></span>
              <span @click="$router.push({ path: '/skulog', query: { id: scope.row.id } })" v-permission="'pms:admin:skugroup:log'" class="color-blue">日志<br></span>
              <span @click="$router.push({ path: '/applysprice', query: { id: scope.row.id, spuProperty: scope.row.spuProperty, isSeries: scope.row.isSeries } })"
                v-permission="'pms:admin:special:add'" class="color-blue" v-if="!['WAIT_AUDIT', 'AUDIT_FAIL'].includes(scope.row.auditStatus)">申请特殊价格<br></span>
              <span v-permission="'pms:admin:sku:group:delete'" v-if="!scope.row.onSale" @click="deleteItem = scope.row.id, deleteDialog = true" class="color-blue">删除</span>
            </template>
          </el-table-column>
        </el-table>
      </div>
      <!--    分页-->
      <v-pagination class="v-pagination" :queryInfo="queryInfo" @changePage="changePage"></v-pagination>
    </div>
    <!-- 下架 -->
    <el-dialog :close-on-click-modal="false" title="确认提示" :visible.sync="downDialog" width="30%">
      <h2>是否下架</h2>
      <p>是否确认下架？</p>
      <span slot="footer" class="dialog-footer">
        <el-button @click="downDialog = false">取 消</el-button>
        <el-button type="primary" @click="downFrame">确 定</el-button>
      </span>
    </el-dialog>
    <!-- 上架 -->
    <el-dialog :close-on-click-modal="false" title="确认提示" :visible.sync="upDialog" width="30%">
      <h2>是否上架</h2>
      <p>是否确认上架？</p>
      <span slot="footer" class="dialog-footer">
        <el-button @click="upDialog = false">取 消</el-button>
        <el-button type="primary" @click="upFrame">确 定</el-button>
      </span>
    </el-dialog>
    <!-- 删除 -->
    <el-dialog :close-on-click-modal="false" title="删除提示" :visible.sync="deleteDialog" width="30%">
      <p>是否确认删除？</p>
      <span slot="footer" class="dialog-footer">
        <el-button @click="deleteDialog = false">取 消</el-button>
        <el-button type="primary" @click="deleteSkuGroup(deleteItem)">确 定</el-button>
      </span>
    </el-dialog>
    <el-dialog :close-on-click-modal="false" title="已关联套系SKU组" :visible.sync="AssociateSeriesDialog" width="500px">
      <el-table :data="AssociateSeriesList" border style="width: 100%">
        <el-table-column prop="id" label="ID"> </el-table-column>
        <el-table-column prop="skuGroupName" label="SKU组名称"> </el-table-column>
      </el-table>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="AssociateSeriesDialog = false">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>
<script>
import VPagination from '@/components/Pagination/index.vue'
import { skuGroupListBySpuId, skuGroupDelete, skuGroupSale, skuGroupListAssociateSeries, skuGroupSaleAll, isZeroPurchaseBuSkuId } from '@/api/pms'
export default {
  name: 'view-sku',
  components: {
    VPagination
  },
  data () {
    return {
      skuId: null,
      multipleSelection: [], // 多选
      AssociateSeriesDialog: false,
      AssociateSeriesList: [],
      deleteDialog: false,
      upDialog: false,
      upFrameId: '',
      downFrameId: '',
      downDialog: false,
      tableData: [],
      queryInfo: {
        pageNum: 1, // 当前显示第几页
        pageSize: 10, // 每一页显示条数
        total: 0
      }
    }
  },
  mounted () {
    sessionStorage.setItem('searchFlag', true)
  },
  created () {
    this.getSkuList()
  },
  methods: {
    to (row, type) {
      if (type === '查看') {
        this.$router.push({
          path: row.isSeries ? '/EditSysSkuGroupDetail' : '/Editskudetails',
          query: {
            spuProperty: row.spuProperty,
            id: row.id,
            auditStatus: row.auditStatus,
            spuId: this.$route.query.id,
            onSale: row.onSale,
            type: 'check',
            startupsSpu: this.$route.query.startupsSpu,
            showPoint: this.$route.query.showPoint
          }
        })
      } else if (type === '编辑') {
        this.$router.push({
          path: row.isSeries ? '/CheckSysSkuGroupDetail' : '/checkskudetails',
          query: {
            spuProperty: row.spuProperty,
            id: row.id,
            auditStatus: row.auditStatus,
            spuId: this.$route.query.id,
            onSale: row.onSale,
            categoryId: this.$route.query.ownCategoryId,
            startupsSpu: this.$route.query.startupsSpu,
            spuType: this.$route.query.spuType,
            showPoint: this.$route.query.showPoint
          }
        })
      } else if (type === '审核') {
        this.$router.push({
          path: row.isSeries ? '/EditSysSkuGroupDetail' : '/Editskudetails',
          query: {
            spuProperty: row.spuProperty,
            id: row.id,
            auditStatus: row.auditStatus,
            spuId: this.$route.query.id,
            onSale: row.onSale,
            type: 'audit',
            startupsSpu: this.$route.query.startupsSpu,
            showPoint: this.$route.query.showPoint
          }
        })
      }
    },
    // 上架
    upFrame () {
      skuGroupSale({ skuGroupId: this.upFrameId, status: true }).then(res => {
        if (res.data.success) {
          this.$message.success('已上架')
          this.getSkuList()
          this.upDialog = false
        }
      })
      // isZeroPurchaseBuSkuId(this.skuId).then(res => {
      //   if (res.data.success) {

      //   } else {
      //     this.$message.error('存在未绑定运费模板的0元购产品')
      //   }
      // })
    },
    // 删除sku组
    deleteSkuGroup (id) {
      skuGroupDelete(id).then(res => {
        if (res.data.success) {
          this.$message.success('删除成功')
          this.getSkuList()
          this.deleteDialog = false
        }
      })
    },
    // 下架
    downFrame () {
      skuGroupSale({ skuGroupId: this.downFrameId, status: false }).then(res => {
        if (res.data.success) {
          this.$message.success('已下架')
          this.getSkuList()
          this.downDialog = false
        } else if (res.data.message === 'pms.sku.has.associate') {
          skuGroupListAssociateSeries(this.downFrameId).then(res => {
            if (res.data.success) {
              this.AssociateSeriesList = res.data.data
              this.downDialog = false
              this.AssociateSeriesDialog = true
            }
          })
        }
      })
    },
    // 批量下架
    undercarriageAll () {
      if (this.multipleSelection.length < 1) {
        this.$message({
          message: '请选择需要下架的sku组',
          type: 'warning'
        })
      } else {
        this.$alert('是否确定下架?', '确认提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(async () => {
          let data = {
            status: false,
            skuGroupIdList: this.multipleSelection
          }
          let res = await skuGroupSaleAll(data)
          if (res.data.success) {
            this.$message({
              type: 'success',
              message: '下架成功!'
            })
            this.getSkuList()
          }
          this.getDetailById()
        })
      }
    },
    // 多选
    handleSelectionChange (val) {
      console.log('val', val)
      this.multipleSelection = val.map(i => {
        return i.id
      })
      console.log('this.multipleSelection', this.multipleSelection)
    },
    // ---------------------------------------
    getSkuList () {
      skuGroupListBySpuId({ spuId: this.$route.query.id, pageNum: this.queryInfo.pageNum, pageSize: this.queryInfo.pageSize }).then((res) => {
        if (res.data.success) {
          this.tableData = res.data.data.records
          this.queryInfo.total = res.data.data.total
        }
      })
    },
    rowClassName ({ row, rowIndex }) {
      row.index = rowIndex
      this.tableData[rowIndex].index = rowIndex
    },
    changePage (val) {
      this.queryInfo = val
      this.getSkuList()
    }
  }
}
</script>
<style scoped lang="less">
@import "index";
@deep: ~">>>";
</style>
